import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { apiEndpoint } from '../../constants/api';
import { userSearchAvatar } from '../../constants/Avatar';

export default function SearchUsers({ skill }){
    const [userData, setUserData] = useState([]);
	const [skills, setSkills] = useState([]);
	const [locationQuery, setLocationQuery] = useState('');
    const [skillQuery, setSkillQuery] = useState('');
    const [searching, setSearching] = useState(false);
	const timeout = useRef();
	const synonymSkill = {
		'Videographer': 'Video Production',
		'Assistant Director (AD)': 'Production Assistant',
		'Audio Engineer': 'Audio / Music / Sound',
		'Art Director': 'Art Department'
	}

	const findLocationData = async ({ target: { value } }) => {
		setSearching(true);
		clearTimeout(timeout.current);
		setLocationQuery(value);
		timeout.current = setTimeout(async () => {
			const { data } = await axios.post(apiEndpoint('/search/users'), {
		      skillQuery,
		      locationQuery: value && value.length > 3 ? value : '',
		    });
		    setUserData(data);
		}, 700);
	}

	const findSkillData = async (value) => {
	    setSearching(true);
	    clearTimeout(timeout.current);
	    setSkillQuery(value);

	    const { data } = await axios.post(apiEndpoint('/search/users'), {
	      skillQuery: value,
	      locationQuery
	    });
	    setUserData(data);
	    setSearching(false);
	};

	const loadSkills = async () => {
      const { data } = await axios.get(apiEndpoint('/admin/skills'));
	  setSkills(data.map(s => ({ value: s.id, label: s.name })))
	}

	const matchSkill = async () => {
		if(skills.length){
			const matchingSkills = skills.filter(
				s => 
				  s.label.toLowerCase() === skill.toLowerCase() ||
				  s.label.toLowerCase() === `${skill.toLowerCase()}s` ||
				  s.label === synonymSkill[skill]);
			if(matchingSkills)
			  findSkillData(matchingSkills);
		}
	}

	useEffect(() => {
	  loadSkills();
    }, []);

	useEffect(() => {
	  matchSkill();
	}, [skills])
  

	return (
		<div>
		  <div className="flex">
          <div className="flex-auto">
            <label className="text-md font-bold font-medium text-gray-900 dark:text-white">Location</label>
            <input
              onChange={findLocationData}
              type="text"
              id="location-search"
              name="location-search"
              className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search Location..."
            />
          </div>
          <div className="flex-auto">
            <label
              htmlFor="skills"
              className="block mb-2 text-lg font-medium text-white">Skills</label>
            <Select
              id="skills"
              name="skills"
              placeholder="Select Skills"
              className="block w-full px-10 p-3"
              value={skillQuery}
              onChange={findSkillData}
              options={skills}
              isMulti>
            </Select>
          </div>
          </div>
          <div className="flex">
            <div className="flex overflow-x-scroll pb-1 my-2 hide-scrollbar">
              { userData ? userData.map( available => {
              	return (
              	  <div id={available.id} className="flex px-5 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
				    <div className="flex flex-col justify-center align-center w-44">
				    <div className="flex justify-end px-4 pt-4">
				    </div>
				    <div className="flex flex-col items-center pb-10">
				        {userSearchAvatar(available.photo, available.gender)}
				        <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">{ available.first_name } { available.last_name }</h5>
				        <span className="text-sm text-gray-500 dark:text-gray-400"></span>
				        <div className="flex my-2 gap-2">

                        { available.instagram_url ? 
                        <div className="flex-none">
                          <a href={available.instagram_url} target="_blank">
                            <img className=" h-8 w-8" src="https://res.cloudinary.com/prodz-com/image/upload/v1689165788/Instagram_Glyph_Gradient_fqfdjf.png" />
                          </a> 
                        </div> : <></>
                        }

                        { available.imdb_url ? 
                        <div className="flex-none">
                          <a href={available.imdb_url} target="_blank">
                            <img className="h-8 w-8" src="https://res.cloudinary.com/prodz-com/image/upload/v1689166357/575px-IMDB_Logo_2016.svg_qkiu4d.png" />
                          </a> 
                        </div> : <></>
                        }

                        { available.linkedin_url ? 
                        <div className="flex-none">
                          <a href={available.linkedin_url} target="_blank">
                            <img className="h-8 w-8" src="https://res.cloudinary.com/prodz-com/image/upload/v1689166538/LI-In-Bug_g1dfif.png" />
                          </a>
                        </div> : <></>
                        }
                        { available.veteran ? 
                        <div className="flex-none">
                          <img className="h-8" src="https://res.cloudinary.com/prodz-com/image/upload/v1689172541/illustration-usa-flag_53876-18165_yumdwy.jpg" />
                        </div> : <></>
                        }
                        { available.lgbtqia ? 
                        <div className="flex-none">
                          <img className="h-8" src="https://res.cloudinary.com/prodz-com/image/upload/v1689167530/lgbtq_syd99k.jpg" />
                        </div> : <></>
                        }
                        </div>
				        <div className="flex mt-4 space-x-3 md:mt-6">
				            <button className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">Message</button>
				        </div>
				    </div>
				    </div>
				</div>
              	)
              }) : <></> }
            </div>
          </div>
		</div>

    )
}